module.exports = __webpack_public_path__ + "static/img/全球司库管理云3.3de5aaf5.png";